'use strict';

/**
 * Parse JSON string safely.
 * @param {string} data - Data to parse.
 * @returns {Object} - Data and error.
 */
function safeJSONParse(data) {
    const output = {
        result: null,
        error: null
    };

    try {
        output.result = JSON.parse(data);
    } catch (e) {
        output.error = e;
    }

    return output;
}

module.exports = {
    safeJSONParse
};
